import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { changeDate, dateWithNoTime } from '../utils/date';
import { NavArrowButton } from './NavArrowButton';
import { compactWeekLabel } from '../utils/mealMapWeekLabel';
export { compactWeekLabel };
export const MealMapHeaderTitle = ({ date, onDateChange, backDisabled, fwdDisabled, firstName, compact = false, }) => {
    return (<View style={styles.container}>
      {compact ? null : <Text style={styles.title}>Meal Map</Text>}
      <View style={styles.weekPickerGroup}>
        <NavArrowButton direction="back" disabled={backDisabled} onPress={() => onDateChange(changeDate(date, -7))}/>
        <Text style={[styles.dateText, compact && styles.dateTextCompact]} numberOfLines={compact ? 1 : undefined}>
          {compact
            ? compactWeekLabel(date, firstName)
            : `${firstName || ''}'s week starting ${dateWithNoTime(date)}`}
        </Text>
        <NavArrowButton direction="forward" disabled={fwdDisabled} onPress={() => onDateChange(changeDate(date, 7))}/>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    title: {
        fontSize: 17,
        fontWeight: '600',
        marginRight: 24,
    },
    weekPickerGroup: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    // prev | title | next, like Calendar and Health.
    dateText: { marginHorizontal: 12, fontSize: 18, fontWeight: '500' },
    dateTextCompact: { marginHorizontal: 4, fontSize: 15, flexShrink: 1 },
});
